// extracted by mini-css-extract-plugin
export default {"logo-box":"navbar_logo-box__E8llC"};